/**
 * @description
 * Objeto permissions
 */

import { Rols } from "./rols.model";
import { Operations } from "./operations.model";

export class Permissions {
    public id:number = null;
    public rolId: Rols = new Rols();
    public operationId: Operations = new Operations();
    public permissionableType:string;
    public permissionableId:number = null;
    public visibility:number=0;

    constructor() {}
  
}